import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MicroLabel, CropMarks } from "@/components/decor/CropMarks";

const FinalDoctrine = () => {
  return (
    <section
      data-testid="final-doctrine"
      className="relative overflow-hidden"
      style={{ background: "#0A0A0A", paddingTop: 140, paddingBottom: 140 }}
    >
      <CropMarks color="#B89B5E" offset={26} length={22} opacity={0.5} />

      {/* faint full bleed CMYK strip */}
      <div
        aria-hidden
        className="absolute top-0 left-0 right-0 flex"
        style={{ height: 2 }}
      >
        <span className="flex-1" style={{ background: "#0072CE" }} />
        <span className="flex-1" style={{ background: "#D6007F" }} />
        <span className="flex-1" style={{ background: "#FFD200" }} />
        <span className="flex-1" style={{ background: "#B89B5E" }} />
      </div>
      <div
        aria-hidden
        className="absolute bottom-0 left-0 right-0 flex"
        style={{ height: 2 }}
      >
        <span className="flex-1" style={{ background: "#B89B5E" }} />
        <span className="flex-1" style={{ background: "#FFD200" }} />
        <span className="flex-1" style={{ background: "#D6007F" }} />
        <span className="flex-1" style={{ background: "#0072CE" }} />
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12 text-center">
        <MicroLabel index={11} accent="#B89B5E" className="justify-center">
          Final Doctrine
        </MicroLabel>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 mx-auto"
          style={{
            fontFamily: "Montserrat",
            fontWeight: 900,
            color: "#F5F1E8",
            fontSize: "clamp(36px, 6.5vw, 96px)",
            lineHeight: 1,
            letterSpacing: "-0.03em",
            textTransform: "uppercase",
            maxWidth: 1100,
          }}
        >
          We do not simply supply products.
          <br />
          <span style={{ color: "#B89B5E" }}>We shape presence.</span>
          <br />
          We print identity into reality.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="mt-14 flex justify-center"
        >
          <a
            href="#contact"
            data-testid="final-doctrine-cta"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="ko-overline inline-flex items-center gap-4 px-9 py-5 transition-all duration-300"
            style={{
              background: "#F5F1E8",
              color: "#0A0A0A",
              fontSize: 12,
              letterSpacing: "0.28em",
              fontWeight: 700,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#B89B5E";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#F5F1E8";
            }}
          >
            Request a Quote
            <ArrowRight size={16} strokeWidth={1.5} />
          </a>
        </motion.div>

        <div className="ko-overline mt-16" style={{ color: "#C0C0C0" }}>
          We do not just print your brand. We place it into the world.
        </div>
      </div>
    </section>
  );
};

export default FinalDoctrine;
